export default __webpack_public_path__ + "static/media/2.ARIFKNIT&SPINNINGLTD(N.R.GROUP).39988dd7.jpg";